exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectMedicalCourse[data-v-ac9d2f6e]{max-width:300px}.doctorMenuList .doctorMenu[data-v-ac9d2f6e],.modalHeading[data-v-ac9d2f6e]{margin-bottom:15px}.modalHeading[data-v-ac9d2f6e]{color:#7d868d;font-size:16px;font-weight:700}", ""]);

// exports
